/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { map, Observable } from 'rxjs';
import {
  EduContentTOCEduContentMetadataInterface,
  EduContentTOCInterface,
  EvaluationWithSubjectsInterface,
} from '../../+models';
import { TocDataResponseInterface } from '../../data';
import { WordInterface } from '../../word';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EduContentTOCApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'EduContentTOCs');
  }

  tree(bookId: number): Observable<EduContentTOCInterface[]> {
    const path = `${bookId}/tree`;
    return this.get<EduContentTOCInterface[]>(path, undefined);
  }

  getEduContentTocsForBook(bookId: number): Observable<EduContentTOCInterface[]> {
    const path = `${bookId}/eduContentTOCs/allowedTocs`;
    return this.get<EduContentTOCInterface[]>(path, undefined);
  }

  patchAttributes(eduContentTOCId: number, update): Observable<EduContentTOCInterface> {
    const path = `${eduContentTOCId}`;
    return this.patch<EduContentTOCInterface>(path, undefined, update);
  }

  deleteEvaluation(eduContentTOCId: number): Observable<boolean> {
    const path = `evaluations/${eduContentTOCId}/delete`;
    return this.delete(path, undefined).pipe(map(() => true));
  }

  moveEvaluation(oldEduContentTOCId: number, newEduContentTOCId: number): Observable<EvaluationWithSubjectsInterface> {
    const path = `evaluations/${oldEduContentTOCId}/move`;
    return this.patch<EvaluationWithSubjectsInterface>(path, undefined, { toEduContentTOCId: newEduContentTOCId });
  }

  updateEduContentTOC(
    eduContentTOCId: number,
    eduContentTOC: Partial<EduContentTOCInterface>
  ): Observable<EduContentTOCInterface> {
    const path = `${eduContentTOCId}/update-toc`;
    return this.post<EduContentTOCInterface>(path, undefined, eduContentTOC);
  }

  updateEduContentMetadataDisplayOrder(
    eduContentTOCId: number,
    displayOrderByEduContentMetadataId: Dictionary<number>
  ): Observable<EduContentTOCEduContentMetadataInterface[]> {
    const path = `${eduContentTOCId}/update-edu-content-metadata-display-order`;
    return this.post<EduContentTOCEduContentMetadataInterface[]>(path, undefined, {
      displayOrderByEduContentMetadataId,
    });
  }

  getData(eduContentTOCId: number, fields?: string | string[]) {
    const path = `${eduContentTOCId}/data`;

    const params = this._getHttpParams({
      fields,
    });

    return this.get<TocDataResponseInterface>(path, params);
  }

  getWordsByTocId(eduContentTOCId: number): Observable<WordInterface[]> {
    const path = `${eduContentTOCId}/words`;

    return this.get<WordInterface[]>(path);
  }
}
